import React from 'react';
import { FormControlLabel, FormGroup, Switch } from '@mui/material';

const EASwitch = ({checked,handleChange, label, style}) => {
  return <FormGroup sx={{...style}}>
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          onChange={handleChange}
        />
      }
      label={<span style={{ fontSize: '14px', color: '#555' }}>{label}</span>}
    />
  </FormGroup>
};

export default EASwitch;